import styled from 'styled-components';

const BigH1 = styled.h1`
    font-size: 100px;
    font-weight: 500;
    line-height: 90px;
    color: black;
    text-transform: none;

    @media (max-width: 800px) {
        font-size: 40px;
        line-height: 40px;
    }
`;

export default BigH1;
